import React from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import { RequestPasswordResetForm, ChangePasswordForm, VerifyResetCodeForm, SignInForm } from '../Auth';

const UnauthorizedLayout = () => {
    const params = useParams()

    return (
        <div className="min-h-screen bg-ltblue flex">
            <div className="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
                <div className="mx-auto w-full max-w-sm lg:w-96">
                    {JSON.stringify(params) === '{}' ?
                        <Routes>
                            <Route path="auth/signin" element={<SignInForm />} />
                        </Routes>
                        :
                        <Routes>
                            <Route path="auth/signin" element={<SignInForm />} />
                            <Route path="auth/reset" element={<RequestPasswordResetForm />} />
                            <Route path="auth/verify" element={<VerifyResetCodeForm />} />
                            <Route path="auth/change" element={<ChangePasswordForm />} />
                        </Routes>
                    }
                </div>
            </div>
            <div className="hidden lg:block relative w-0 flex-1">
                <div className='flex flex-row h-screen place-content-center place-items-center'>
                    <img className='w-4/12' src="../../assets/purpleOneLogo.jpg" alt="panel" />
                </div>

            </div>
        </div>
    )
}

export default UnauthorizedLayout;